import { createRoot } from 'react-dom/client'
import Lenis from 'lenis'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Scene from './Scene'
import Overlay from './Overlay/Overlay'
import CustomLoader from './Loader'

gsap.registerPlugin(ScrollTrigger)

// Initialize Lenis smooth scroll (starts stopped)
const lenis = new Lenis({
  duration: 1.4,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  smoothWheel: true,
  wheelMultiplier: 0.8,
  touchMultiplier: 1.5,
})

// Block scroll until intro camera animation finishes
lenis.stop()

// Export so CameraAnimation can unlock it
window.__lenis = lenis

// Connect Lenis to GSAP ScrollTrigger
lenis.on('scroll', ScrollTrigger.update)

gsap.ticker.add((time) => {
  lenis.raf(time * 1000)
})

gsap.ticker.lagSmoothing(0)

const root = createRoot(document.getElementById('root'))

root.render(
  <>
    <Scene />
    <Overlay />
    <CustomLoader />
  </>
)
